var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1523_1452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10C19.5262 10.5822 20.1562 11.3371 20.5902 12.2049C21.0241 13.0728 21.25 14.0297 21.25 15C21.25 15.9703 21.0241 16.9272 20.5902 17.7951C20.1562 18.6629 19.5262 19.4178 18.75 20",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.125 6.25C23.43 7.30456 24.4825 8.63766 25.2056 10.1517C25.9287 11.6656 26.3039 13.3222 26.3039 15C26.3039 16.6778 25.9287 18.3344 25.2056 19.8483C24.4825 21.3623 23.43 22.6954 22.125 23.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.75H5C4.66848 18.75 4.35054 18.6183 4.11612 18.3839C3.8817 18.1495 3.75 17.8315 3.75 17.5V12.5C3.75 12.1685 3.8817 11.8506 4.11612 11.6161C4.35054 11.3817 4.66848 11.25 5 11.25H7.5L11.875 5.62503C11.9843 5.41282 12.1658 5.24668 12.3869 5.15664C12.6079 5.0666 12.8539 5.0586 13.0803 5.13408C13.3068 5.20956 13.4987 5.36354 13.6215 5.5682C13.7444 5.77286 13.7899 6.0147 13.75 6.25003V23.75C13.7899 23.9853 13.7444 24.2272 13.6215 24.4319C13.4987 24.6365 13.3068 24.7905 13.0803 24.866C12.8539 24.9415 12.6079 24.9334 12.3869 24.8434C12.1658 24.7534 11.9843 24.5872 11.875 24.375L7.5 18.75Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1523_1452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/Volume.eee8aa2950e9d0b7e0666cdb86f14431.svg";
export { ForwardRef as ReactComponent };